module.exports = __webpack_public_path__ + "static/media/53_A.07cc072c.png";